import moment from "moment";
import { BudgetModel } from "./budget.model";
import { ProposalModel } from "./proposal.model";

export class DeliveryModel {
  public id: number;

  public phase: string;
  public deliveryDate: Date;
  public description: string;

  public budgetId: number | null;
  public proposalId: number | null;

  public budget: BudgetModel | null;
  public proposal: ProposalModel | null;

  public createdAt: Date;
  public updatedAt: Date;

  constructor($obj?: any) {
    this.id = $obj && $obj.id ? $obj.id : '#new' + moment().valueOf();

    this.phase = $obj && $obj.phase ? $obj.phase : '';
    this.deliveryDate = $obj && $obj.deliveryDate ? new Date($obj.deliveryDate) : new Date();
    this.description = $obj && $obj.description ? $obj.description : '';

    this.budgetId = $obj && $obj.budgetId ? $obj.budgetId : $obj && $obj.budget ? $obj.budget.id : null;
    this.proposalId = $obj && $obj.proposalId ? $obj.proposalId : $obj && $obj.proposal ? $obj.proposal.id : null;

    this.budget = $obj && $obj.budget ? new BudgetModel($obj.budget) : null;
    this.proposal = $obj && $obj.proposal ? new ProposalModel($obj.proposal) : null;

    this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : new Date();
    this.updatedAt = $obj && $obj.updatedAt ? new Date($obj.updatedAt) : new Date();
  }

  toAPI() {
    return {
      phase: this.phase,
      deliveryDate: this.deliveryDate,
      description: this.description,
      budgetId: this.budgetId,
      proposalId: this.proposalId,
    };
  }

  setFormByBudget(form: any) {
    this.id = form.id;
    this.phase = form.phase;
    this.deliveryDate = new Date(form.date);
    this.description = form.description;

    return this;
  }

  toBudgetAPI(create: boolean) {
    if (create) {
      return {
        phase: this.phase,
        deliveryDate: this.deliveryDate.toISOString(),
        description: this.description
      };
    } else {
      return {
        id: this.id,
        phase: this.phase,
        deliveryDate: this.deliveryDate.toISOString(),
        description: this.description
      };
    }
  }
}
